import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import { CommonSelect, CommonToolTip, CstmPagination } from "../../../../components/Common/Common";
import { Link, useNavigate } from "react-router-dom";
import { ADD_MANAGE_GROUP, MANAGE_GROUP_DETAIL } from "config/paths";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { useDeleteGroupMutation, useGetGroupListQuery } from "store/services/group";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { convertToMomentDate, successMessageToast } from "helpers/common";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { CLIENT_TYPE, CLIENT_TYPES } from "config/constants";
import { EDIT_MANAGE_GROUP } from "config/paths";

const ManageGroup = () => {

  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filter, setFilter] = useState({ search: "", status: "", group_type: "", sort: { column: "id", direction: "desc" } });

  const { data, isLoading, isError, isFetching } = useGetGroupListQuery({ page: currentPage, limit: pageSize, ...filter });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const [deleteGroup, { isLoading: deleteGroupLoading }] = useDeleteGroupMutation();

  const column = [
    {
      head: "Group Name",
      accessor: "GroupName",
      isComponent: true,
      component: (item, ind) => (
        <div className="d-flex gap-2 align-items-center">
          <h6 className="m-0 fw-sbold">{item?.group_name || ""}</h6>
        </div>
      ),
    },
    {
      head: "Start Date",
      accessor: "StartDate",
      isComponent: true,
      component: (item, ind) => (
        <>{convertToMomentDate(item?.start_date)}</>
      ),
    },
    {
      head: "End Date",
      accessor: "EndDate",
      isComponent: true,
      component: (item, ind) => (
        <>{convertToMomentDate(item?.end_date)}</>
      ),
    },
    {
      head: "Group Type",
      accessor: "GroupType",
      isComponent: true,
      component: (item, ind) => (
        <>{CLIENT_TYPE[item?.group_type]}</>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <p
          style={{ width: 80 }}
          className={`${item?.status == "active"
            ? "greenStatus"
            : "redStatus"
            } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
        >
          {item?.status}
        </p>
      ),
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <CommonToolTip
            text={"Edit"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={e => {
                e.stopPropagation();
                navigate(EDIT_MANAGE_GROUP.replace(":id", item?.id))

              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <circle cx="13.5" cy="13.5" r="13.5" fill="#EBFFEB" />
                <mask
                  id="mask0_0_4552"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="5"
                  y="4"
                  width="18"
                  height="18"
                >
                  <rect x="5" y="4" width="18" height="18" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_0_4552)">
                  <path
                    d="M6.5 21.9997V19.7497H21.5V21.9997H6.5ZM9.5 16.3099H10.4274L16.6524 10.0963L16.1808 9.61761L15.7136 9.15749L9.5 15.3825V16.3099ZM8.375 17.4349V14.9036L16.7823 6.50792C16.8909 6.3993 17.0142 6.31711 17.1523 6.26136C17.2901 6.20561 17.4336 6.17773 17.5828 6.17773C17.732 6.17773 17.8765 6.20561 18.0163 6.26136C18.156 6.31711 18.2841 6.40317 18.4004 6.51955L19.3019 7.43249C19.4183 7.54111 19.5024 7.66555 19.5543 7.8058C19.6062 7.94592 19.6321 8.0908 19.6321 8.24042C19.6321 8.38067 19.6058 8.52011 19.5532 8.65873C19.5006 8.79748 19.4168 8.9243 19.3019 9.03917L10.9062 17.4349H8.375ZM16.6524 10.0963L16.1808 9.61761L15.7136 9.15749L16.6524 10.0963Z"
                    fill="#071E3E"
                  />
                </g>
              </svg>
            </Button>}
          />
          <CommonToolTip
            text={"Delete"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={(e) => {

                e.stopPropagation();
                if (!isFetching && !deleteGroupLoading) {
                  setCurrentEntry(item);
                  setShowModal(true);
                }
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <circle cx="13.5" cy="13.5" r="13.5" fill="#FFE3E5" />
                <mask
                  id="mask0_26_18856"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="5"
                  y="5"
                  width="18"
                  height="18"
                >
                  <rect x="5" y="5" width="18" height="18" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_26_18856)">
                  <path
                    d="M10.4808 20.3753C10.1068 20.3753 9.78731 20.2429 9.52231 19.978C9.25744 19.713 9.125 19.3935 9.125 19.0195V9.50029H8.375V8.37529H11.75V7.71191H16.25V8.37529H19.625V9.50029H18.875V19.0195C18.875 19.3984 18.7438 19.719 18.4813 19.9815C18.2188 20.244 17.8981 20.3753 17.5192 20.3753H10.4808ZM17.75 9.50029H10.25V19.0195C10.25 19.0869 10.2716 19.1422 10.3149 19.1854C10.3581 19.2287 10.4134 19.2503 10.4808 19.2503H17.5192C17.5769 19.2503 17.6298 19.2262 17.6778 19.1781C17.7259 19.1301 17.75 19.0772 17.75 19.0195V9.50029ZM12.053 17.7503H13.1778V11.0003H12.053V17.7503ZM14.8222 17.7503H15.947V11.0003H14.8222V17.7503Z"
                    fill="#071E3E"
                  />
                </g>
              </svg>
            </Button>}
          />
        </div>
      ),
    },
  ];

  const resetFilter = () => {
    setFilter({ search: "", status: "", group_type: "", sort: { column: "id", direction: "desc" } });
    setCurrentPage(1)
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1);
  };

  const handleDelete = async () => {
    try {

      setShowModal(false);

      const result = await deleteGroup(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error deleting group", err);
    };
  };

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleDelete}
        type="delete"
      />
      <section className="client position-relative py-4">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <TableHeader
                    heading={"Group List"}
                    handleFilterChange={handleFilterChange}
                    filter={filter}
                    resetFilter={resetFilter}
                    showStatusFilter
                    searchPlaceholder="Group Name"
                    filterComponent={
                      <>
                        <li>
                          <CommonSelect
                            isFilter
                            placeholder={CLIENT_TYPES.find(x => x.value == filter?.group_type)?.label || "Group Type"}
                            option={CLIENT_TYPES}
                            value={filter?.group_type}
                            onChange={(selected) => {
                              handleFilterChange("group_type")(selected?.value);
                            }}
                          />
                        </li>
                      </>
                    }

                  />
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <li className="">
                      <Link
                        to={ADD_MANAGE_GROUP}
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                      >
                        <span className="icn me-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                          >
                            <mask
                              id="mask0_0_4440"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="19"
                              height="19"
                            >

                              <rect
                                width="18.7197"
                                height="18.7197"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_0_4440)">
                              <path
                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </span>{" "}
                        Add New Group
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || deleteGroupLoading) && <LoadingOverlay />}
                    <TableLayout
                      data={data?.records || []}
                      column={column}
                      handleSort={handleFilterChange("sort")}
                      filter={filter}
                      url={MANAGE_GROUP_DETAIL.replace("/:id", "")}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageGroup;
